import styled from '@emotion/styled';
import React from 'react';

export interface IProps {
  children: React.ReactNode;
  [key: string]: any;
}

const Footer = styled.tfoot`
  tr {
    td {
      border: none;
      padding: inherit;
    }
    td:last-child {
      font-weight: 500;
    }
  }
`;

export const Tfoot = ({ children, ...rest }: IProps) => {
  return <Footer {...rest}>{children}</Footer>;
};
